export default __webpack_public_path__ + "static/media/full-logo.0bd7aff8.svg";